export const IconUpload = ({ width = '36', height = '36', fill = '' }) => {
  return (
    <svg
      data-name="Component 109 – 1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 22 22"
    >
      <path
        data-name="Rectangle 21668"
        d="M9 .5A8.5 8.5 0 1 0 17.5 9 8.51 8.51 0 0 0 9 .5M9 0a9 9 0 1 1-9 9 9 9 0 0 1 9-9z"
        transform="translate(2 2)"
        fill={fill}
      />
      <path
        data-name="Icon open-data-transfer-upload"
        d="M0 0v1.25h10V0zm5 2.5L1.25 6.25h2.5V10h2.5V6.25h2.5z"
        transform="translate(6 6)"
        fill={fill}
      />
    </svg>
  )
}

export const IconSearch = ({ width = '36', height = '36', fill = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill={fill} viewBox="0 0 22 22">
      <path
        data-name="Search"
        d="m20.609 18.285-3.4-3.389A7.917 7.917 0 0 0 18.904 10a8 8 0 1 0-8 8 7.917 7.917 0 0 0 4.9-1.689l3.389 3.4a1.004 1.004 0 1 0 1.42-1.42zM4.909 10a6 6 0 1 1 1.757 4.241A6 6 0 0 1 4.909 10z"
      />
    </svg>
  )
}

export const IconScan = ({ width = '36', height = '36', fill = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 22">
      <path data-name="Rectangle 21529" transform="translate(4.639 9.599)" fill={fill} d="M0 0h11.853v1.054H0z" />
      <path
        data-name="Path 24858"
        d="M16.492 5.95 4.886 0 4.4.937l11.611 5.951a1.714 1.714 0 0 1 .936 1.531v.934H0v2.558A2.689 2.689 0 0 0 2.686 14.6H18V8.419a2.764 2.764 0 0 0-1.508-2.469M3.2 12.636a.661.661 0 1 1 .661-.661.661.661 0 0 1-.661.661"
        transform="translate(0 .001)"
        fill={fill}
      />
    </svg>
  )
}

export const IconSuccess = ({ width = '36', height = '36', fill = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 22">
      <path
        data-name="Path 24838"
        d="M9 16.875A7.875 7.875 0 1 1 16.875 9 7.875 7.875 0 0 1 9 16.875zM9 18a9 9 0 1 0-9-9 9 9 0 0 0 9 9z"
        fill={fill}
        transform="translate(2 2)"
      />
      <path
        data-name="Path 24839"
        d="M11.826 5a.264.264 0 0 0-.023.025L7.9 10 5.542 7.645a.844.844 0 0 0-1.193 1.193l2.977 2.978a.844.844 0 0 0 1.214-.023l4.491-5.614A.844.844 0 1 0 11.826 5z"
        transform="translate(2.515 2.593)"
        fill={fill}
      />
    </svg>
  )
}

export const IconBin = ({ width = '36', height = '36', fill = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 22">
      <g data-name="Rectangle 20409" style={{ stroke: 'transparent', fill: 'none' }}>
        <path style={{ stroke: 'none' }} d="M0 0h22v22H0z" />
        <path style={{ fill: 'none' }} d="M.5.5h21v21H.5z" />
      </g>
      <path
        d="M7.188 1.125h3.375a.563.563 0 0 1 .563.563v1.125h-4.5V1.688a.563.563 0 0 1 .562-.563zm5.062 1.688V1.688A1.687 1.687 0 0 0 10.563 0H7.188A1.688 1.688 0 0 0 5.5 1.688v1.125H1.563a.563.563 0 0 0 0 1.125h.605l.96 11.993A2.25 2.25 0 0 0 5.371 18h7.009a2.25 2.25 0 0 0 2.243-2.07l.96-11.992h.605a.563.563 0 0 0 0-1.125H12.25zm2.2 1.125L13.5 15.84a1.125 1.125 0 0 1-1.122 1.035H5.371a1.125 1.125 0 0 1-1.122-1.035L3.3 3.938zM6.03 5.063a.562.562 0 0 1 .594.529l.562 9.562a.562.562 0 1 1-1.123.068L5.5 5.659a.562.562 0 0 1 .529-.6zm5.69 0a.563.563 0 0 1 .529.6l-.562 9.563a.562.562 0 1 1-1.123-.068l.563-9.562a.563.563 0 0 1 .594-.529zm-2.845 0a.563.563 0 0 1 .563.563v9.563a.563.563 0 0 1-1.125 0V5.625a.563.563 0 0 1 .562-.562z"
        transform="translate(2.125 2)"
        style={{ fill: fill }}
      />
    </svg>
  )
}
export const IconUser = ({ width = '36', height = '36', fill = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 22">
      <defs>
        <clipPath id="0kcs874g9a">
          <path data-name="Rectangle 21537" style={{ fill: fill }} d="M0 0h18v15.708H0z" />
        </clipPath>
      </defs>
      <g data-name="Rectangle 20409" style={{ stroke: 'transparent', fill: 'none' }}>
        <path style={{ stroke: 'none' }} d="M0 0h22v22H0z" />
        <path style={{ fill: 'none' }} d="M.5.5h21v21H.5z" />
      </g>
      <g data-name="Group 24417">
        <g data-name="Group 24416" style={{ clipPath: 'url(#0kcs874g9a)' }} transform="translate(2 3)">
          <path
            data-name="Path 24882"
            d="M17.995 210.107a2.32 2.32 0 0 0-1.82-2.256 6.981 6.981 0 0 0-1.414-.075 2.285 2.285 0 0 0-1.818.881c-.12.146-.216.313-.329.478-.032-.03-.062-.057-.09-.085a4.231 4.231 0 0 0-2.186-1.195 8.558 8.558 0 0 0-1.891-.081 4.147 4.147 0 0 0-2.833 1.138c-.08.074-.158.15-.244.232-.043-.076-.075-.138-.111-.2a2.279 2.279 0 0 0-1.722-1.144 9.37 9.37 0 0 0-1.192-.031 2.386 2.386 0 0 0-2.264 1.756c-.029.106-.054.213-.081.32v4.332c.014.037.031.074.043.112a1.035 1.035 0 0 0 1.007.732h3.2a1.2 1.2 0 0 0 .465.847 4.022 4.022 0 0 0 .557.28h7.452a4.4 4.4 0 0 0 .622-.338 1.153 1.153 0 0 0 .4-.789h3.169A1.061 1.061 0 0 0 18 213.944c0-1.279.007-2.558 0-3.837m-13.554.667a11.708 11.708 0 0 0-.178 1.178c-.031.6-.01 1.208-.011 1.813v.2h-3.2v-3.722a1.326 1.326 0 0 1 1.408-1.41 6.623 6.623 0 0 1 1 .034 1.274 1.274 0 0 1 1.068 1.275 4.257 4.257 0 0 1-.088.636m8.248 4.082c0 .188-.058.24-.261.24H5.6c-.244 0-.288-.043-.288-.284v-2.763a3.194 3.194 0 0 1 3.211-3.219 9.467 9.467 0 0 1 1.626.077 3.154 3.154 0 0 1 2.539 3.009c.016.979 0 1.959 0 2.938m4.253-.973a.71.71 0 0 1-.011.082h-3.186v-.187c-.011-.745 0-1.49-.041-2.233a4.688 4.688 0 0 0-.189-.89 1.4 1.4 0 0 1 .853-1.757.439.439 0 0 1 .135-.036 10.592 10.592 0 0 1 1.4.01 1.247 1.247 0 0 1 1.038 1.227c.01 1.261 0 2.522 0 3.783"
            transform="translate(0 -200.445)"
            style={{ fill: fill }}
          />
          <path
            data-name="Path 24883"
            d="M172.267 6.1a3.059 3.059 0 0 0 .779-5.858A7.771 7.771 0 0 0 172.19 0h-.633a.643.643 0 0 1-.1.03 3.061 3.061 0 0 0 .809 6.069m-.394-5.042a2.007 2.007 0 1 1-2 2 2.011 2.011 0 0 1 2-2"
            transform="translate(-162.875)"
            style={{ fill: fill }}
          />
          <path
            data-name="Path 24884"
            d="M26.908 67.889a1.937 1.937 0 1 0-1.941-1.928 1.94 1.94 0 0 0 1.941 1.928m0-2.817a.88.88 0 1 1-.885.877.882.882 0 0 1 .885-.877"
            transform="translate(-24.087 -61.761)"
            style={{ fill: fill }}
          />
          <path
            data-name="Path 24885"
            d="M378.207 67.889a1.937 1.937 0 1 0-1.926-1.943 1.941 1.941 0 0 0 1.926 1.943m.021-2.817a.88.88 0 1 1-.893.869.882.882 0 0 1 .893-.869"
            transform="translate(-363.029 -61.761)"
            style={{ fill: fill }}
          />
        </g>
      </g>
    </svg>
  )
}

export const IconCart = ({ width = '36', height = '36', fill = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 22">
      <g data-name="Rectangle 20409" style={{ stroke: 'transparent', fill: 'none' }}>
        <path style={{ stroke: 'none' }} d="M0 0h22v22H0z" />
        <path style={{ fill: 'none' }} d="M.5.5h21v21H.5z" />
      </g>
      <path
        data-name="Path 24861"
        d="M12.425 6.525a.6.6 0 1 0-.85-.85L8.4 8.852 7.025 7.475a.6.6 0 0 0-.85.85l1.8 1.8a.6.6 0 0 0 .85 0z"
        transform="translate(3.2 1.9)"
        style={{ fill: fill }}
      />
      <path
        data-name="Path 24862"
        d="M.6 1a.6.6 0 1 0 0 1.2h1.332l.481 1.928 1.8 9.582a.6.6 0 0 0 .589.49H6a2.4 2.4 0 1 0 2.4 2.4A2.4 2.4 0 0 0 6 14.2h8.4a2.4 2.4 0 1 0 2.4 2.4 2.4 2.4 0 0 0-2.4-2.4h1.2a.6.6 0 0 0 .589-.49l1.8-9.6a.6.6 0 0 0-.589-.71H3.468l-.486-1.945A.6.6 0 0 0 2.4 1zm4.7 12L3.723 4.6h12.955L15.1 13zm1.9 3.6A1.2 1.2 0 1 1 6 15.4a1.2 1.2 0 0 1 1.2 1.2zm8.4 0a1.2 1.2 0 1 1-1.2-1.2 1.2 1.2 0 0 1 1.2 1.2z"
        transform="translate(2 1)"
        style={{ fill: fill }}
      />
    </svg>
  )
}

export const IconFileEarMark = ({ width = '36', height = '36', fill = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 22">
      <path data-name="Rectangle 20409" style={{ fill: 'none' }} d="M0 0h22v22H0z" />
      <g data-name="file-earmark-text">
        <path
          data-name="Path 24932"
          d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"
          transform="translate(3 3.273)"
          style={{ fill: fill }}
        />
        <path
          data-name="Path 24933"
          d="M10.438 0H4.25A2.25 2.25 0 0 0 2 2.25v13.5A2.25 2.25 0 0 0 4.25 18h9a2.25 2.25 0 0 0 2.25-2.25V5.063zm0 1.125v2.25a1.687 1.687 0 0 0 1.688 1.688h2.25V15.75a1.125 1.125 0 0 1-1.125 1.125h-9a1.125 1.125 0 0 1-1.126-1.125V2.25A1.125 1.125 0 0 1 4.25 1.125z"
          style={{ fill: fill }}
          transform="translate(2.25 2)"
        />
      </g>
    </svg>
  )
}

export const IconPin = ({ width = '36', height = '36', fill = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 22">
      <g data-name="Rectangle 20409" style={{ stroke: 'transparent', fill: 'none' }}>
        <path style={{ stroke: 'none' }} d="M0 0h22v22H0z" />
        <path style={{ fill: 'none' }} d="M.5.5h21v21H.5z" />
      </g>
      <path
        data-name="pin"
        d="M4.289.164A.563.563 0 0 1 4.688 0h7.875a.563.563 0 0 1 .563.563 2.347 2.347 0 0 1-.726 1.663 3.216 3.216 0 0 1-.4.335v4.986l.088.054a6.631 6.631 0 0 1 .845.624 3.4 3.4 0 0 1 1.317 2.463.563.563 0 0 1-.562.563h-4.5v5.063c0 .31-.252 1.688-.562 1.688s-.562-1.377-.562-1.687V11.25h-4.5A.563.563 0 0 1 3 10.688a3.4 3.4 0 0 1 1.316-2.463 6.661 6.661 0 0 1 .934-.678V2.562a3.116 3.116 0 0 1-.4-.335A2.349 2.349 0 0 1 4.125.563a.562.562 0 0 1 .164-.4zm1.778 1.584zm0 0a.562.562 0 0 1 .308.5v5.627a.562.562 0 0 1-.31.5l-.014.008-.061.034a5.537 5.537 0 0 0-.93.653 2.975 2.975 0 0 0-.816 1.053h8.766a2.975 2.975 0 0 0-.816-1.053 5.529 5.529 0 0 0-.991-.686l-.013-.007a.562.562 0 0 1-.311-.5V2.25a.563.563 0 0 1 .332-.515 2 2 0 0 0 .395-.3 1.522 1.522 0 0 0 .241-.3h-6.44a1.555 1.555 0 0 0 .241.3 2 2 0 0 0 .416.312z"
        transform="translate(2.375 2)"
        style={{ fill: fill }}
      />
    </svg>
  )
}

export const IconCalculator = ({ width = '36', height = '36', fill = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 22">
      <defs>
        <clipPath id="keyfcewh6a">
          <path data-name="Rectangle 21534" style={{ fill: '#b9b9b9' }} d="M0 0h18v18.027H0z" />
        </clipPath>
      </defs>
      <g data-name="Rectangle 20409" style={{ stroke: 'transparent', fill: 'none' }}>
        <path style={{ stroke: 'none' }} d="M0 0h22v22H0z" />
        <path style={{ fill: 'none' }} d="M.5.5h21v21H.5z" />
      </g>
      <g data-name="Group 24412">
        <g data-name="Group 24411" style={{ clipPath: 'url(#keyfcewh6a)' }} transform="translate(2 2)">
          <path
            data-name="Path 24865"
            d="M17.449 11.359a14.618 14.618 0 0 0-1.982-2.744c-.179-.208-.362-.412-.552-.628a1.017 1.017 0 0 0-.353-1.9c.247-.245.478-.465.7-.7a1.017 1.017 0 0 0-1.22-1.6c-.1.053-.164.06-.212-.07a1.047 1.047 0 0 0-.929-.778c0-.238.006-.482 0-.726a3.653 3.653 0 0 0-.054-.769 1.83 1.83 0 0 0-1.471-1.41A.818.818 0 0 1 11.28 0H1.616a5.193 5.193 0 0 0-.778.327 1.77 1.77 0 0 0-.8 1.2A.671.671 0 0 1 0 1.62v12.217c.028.1.053.2.083.3a1.848 1.848 0 0 0 1.724 1.319c1.194.016 2.389.007 3.584.008h2.653a.237.237 0 0 1 .239.127 4.97 4.97 0 0 0 3.588 2.365c.143.025.286.048.429.071h1.089c.36-.071.728-.114 1.078-.218a4.694 4.694 0 0 0 3.26-2.9 4.194 4.194 0 0 0-.277-3.551M14.877 7.1c0 .266-.2.437-.505.438h-3.054c-.31 0-.5-.171-.5-.438s.194-.437.5-.437h3.054c.309 0 .505.173.5.438m-1.737-3.469a.611.611 0 0 1 .152.249.661.661 0 0 0 1 .416.457.457 0 0 1 .55.727q-.492.5-.994.994a.3.3 0 0 1-.183.073c-.269.008-.538 0-.808 0h-.808a.3.3 0 0 1-.185-.066q-.516-.5-1.02-1.019a.448.448 0 0 1-.091-.534.44.44 0 0 1 .448-.246.583.583 0 0 1 .182.057.661.661 0 0 0 1.029-.428.446.446 0 0 1 .728-.225m-5.347 8.796v-.311a.656.656 0 0 0-.719-.722q-.615-.006-1.23 0a.648.648 0 0 0-.719.718v.458a.624.624 0 0 0 .6.6c.48.01.96.007 1.441 0 .223 0 .337-.084.591-.385a4.208 4.208 0 0 0 .191 2.113c-.072 0-.124.007-.176.007H1.951a1.311 1.311 0 0 1-1.372-1.123 1.681 1.681 0 0 1-.016-.28V1.97A1.321 1.321 0 0 1 1.973.564h8.961a1.318 1.318 0 0 1 1.405 1.409c0 .329.006.657 0 .986a.441.441 0 0 1-.1.2 6.032 6.032 0 0 0-.359.528c-.065.123-.1.175-.242.1a3.505 3.505 0 0 0-.5-.165v-.624a.656.656 0 0 0-.72-.7H2.53a.675.675 0 0 0-.77.763v1.25a.658.658 0 0 0 .726.731h7.52a.3.3 0 0 1 .275.151 8.654 8.654 0 0 0 .627.686 2.228 2.228 0 0 0 .222.18l-.54.268a5.19 5.19 0 0 0-.59-.092c-.392-.013-.785-.006-1.177 0a.647.647 0 0 0-.692.677 4.247 4.247 0 0 0 .007.51.612.612 0 0 0 .6.581q.728.021 1.458 0a1.737 1.737 0 0 0 .418-.126l.162.113c-.235.268-.462.534-.7.791-.031.033-.108.032-.164.032H8.84a.657.657 0 0 0-.71.7v.3a.7.7 0 0 0 .558.791 7.1 7.1 0 0 0-.9 1.829m-1.023.18h-.316c-.2 0-.4-.006-.6 0-.133.006-.179-.049-.172-.176a2.354 2.354 0 0 0 0-.3c-.008-.126.037-.181.17-.179.4.005.808 0 1.212 0 .121 0 .167.048.165.168-.009.59.067.471-.462.484M2.32 3.058c0-.156.054-.2.205-.2h7.848c.165 0 .222.056.207.215a2.222 2.222 0 0 0 0 .316.692.692 0 0 1-.223.671c-.109.084-.15.258-.237.418H2.569c-.245 0-.246 0-.246-.239 0-.393.006-.786 0-1.179m7.454 4.384h-.9c-.132 0-.192-.037-.189-.179.011-.573-.064-.461.456-.472h.316c.2 0 .4.005.6 0 .126 0 .181.037.178.17-.013.576.079.473-.463.482m-.192 1.927a5.419 5.419 0 0 1-.466.6c-.067.066-.225.056-.339.044-.034 0-.08-.128-.08-.2 0-.517-.061-.437.426-.443h.459m7.561 5.5a3.965 3.965 0 0 1-2.307 2.215 5.023 5.023 0 0 1-4.843-.472 3.681 3.681 0 0 1-1.729-3.323 4.409 4.409 0 0 1 .812-2.253 21.5 21.5 0 0 1 2.3-2.859.3.3 0 0 1 .2-.076c.427-.007.855 0 1.282 0h1.265a.277.277 0 0 1 .184.064 18.794 18.794 0 0 1 2.536 3.25 3.706 3.706 0 0 1 .3 3.454"
            style={{ fill: fill }}
          />
          <path
            data-name="Path 24866"
            d="M61.724 250.058c-.462-.01-.924-.011-1.386 0a.637.637 0 0 0-.635.659v.439a.649.649 0 0 0 .686.681h1.316a.653.653 0 0 0 .666-.652 5.352 5.352 0 0 0 0-.474.646.646 0 0 0-.647-.652m-.368 1.216h-.946c-.1 0-.148-.042-.145-.147.012-.613-.089-.5.467-.509.3-.005.6 0 .894 0 .135 0 .189.046.187.184-.011.555.067.466-.456.474"
            transform="translate(-57.6 -241.246)"
            style={{ fill: fill }}
          />
          <path
            data-name="Path 24867"
            d="M147.376 250.049q-.7-.018-1.4 0a.633.633 0 0 0-.629.646c-.005.152 0 .3 0 .457a.647.647 0 0 0 .674.675H147.354a.643.643 0 0 0 .656-.623 3.72 3.72 0 0 0 0-.544.63.63 0 0 0-.629-.611m-.385 1.215H146.068c-.11 0-.16-.039-.158-.154.011-.608-.083-.493.474-.5.3-.005.6 0 .893 0 .126 0 .181.042.179.172-.009.581.066.475-.46.486"
            transform="translate(-140.223 -241.236)"
            style={{ fill: fill }}
          />
          <path
            data-name="Path 24868"
            d="M60.32 178.711q.7.018 1.4 0a.631.631 0 0 0 .635-.622 4.149 4.149 0 0 0 0-.527.644.644 0 0 0-.656-.622h-1.35a.64.64 0 0 0-.658.652q-.005.237 0 .474a.625.625 0 0 0 .627.644m.411-1.207c.3-.006.6 0 .893 0 .127 0 .18.042.177.172-.011.567.074.471-.465.48H60.406c-.11 0-.158-.04-.155-.155.014-.607-.089-.484.478-.495"
            transform="translate(-57.589 -170.709)"
            style={{ fill: fill }}
          />
          <path
            data-name="Path 24869"
            d="M61.757 323.521q-.736-.022-1.473 0a.615.615 0 0 0-.593.62c-.005.164 0 .328 0 .492a.64.64 0 0 0 .656.654h1.351a.644.644 0 0 0 .658-.62 3.868 3.868 0 0 0 0-.544.619.619 0 0 0-.6-.6m-.42 1.2h-.315c-.2 0-.4-.005-.6 0-.125 0-.181-.034-.177-.168.016-.576-.09-.474.474-.483h.875c.137 0 .2.036.2.188-.013.555.068.454-.462.464"
            transform="translate(-57.585 -312.119)"
            style={{ fill: fill }}
          />
          <path
            data-name="Path 24870"
            d="M146 178.659c.222.007.444 0 .666 0h.754a.614.614 0 0 0 .574-.545 3.37 3.37 0 0 0 0-.683.609.609 0 0 0-.6-.539c-.479-.009-.959-.01-1.438 0a.625.625 0 0 0-.609.607 5.046 5.046 0 0 0 0 .492.635.635 0 0 0 .656.671m.369-1.211h.931c.105 0 .151.043.15.145-.006.615.075.5-.457.505-.3.006-.609 0-.913 0-.127 0-.178-.042-.176-.173.013-.582-.076-.466.465-.478"
            transform="translate(-140.221 -170.654)"
            style={{ fill: fill }}
          />
          <path
            data-name="Path 24871"
            d="M323.88 287.907a3.035 3.035 0 0 0-.766-.328c-.236-.081-.491-.11-.726-.193a.526.526 0 0 1-.393-.507.6.6 0 0 1 .35-.566.977.977 0 0 1 1.354.4c.1.186.244.249.4.173s.191-.235.1-.423a1.29 1.29 0 0 0-.842-.743c-.2-.055-.272-.135-.255-.341a.276.276 0 1 0-.55-.01c.025.23-.063.331-.277.359a.468.468 0 0 0-.146.059 1.16 1.16 0 0 0-.7 1.092 1.057 1.057 0 0 0 .731 1.018c.231.093.484.13.722.207a2.642 2.642 0 0 1 .648.249.531.531 0 0 1-.071.95 1.329 1.329 0 0 1-.939.1.838.838 0 0 1-.655-.571c-.068-.209-.214-.293-.382-.234s-.215.213-.15.412a1.311 1.311 0 0 0 .884.883c.219.07.373.125.336.405-.02.147.136.262.278.259a.281.281 0 0 0 .273-.287v-.244a5.327 5.327 0 0 0 .651-.249 1.089 1.089 0 0 0 .121-1.876"
            transform="translate(-309.998 -275.041)"
            style={{ fill: fill }}
          />
        </g>
      </g>
    </svg>
  )
}

export const IconMegaPhone = ({ width = '36', height = '36', fill = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 22">
      <g data-name="Rectangle 20409" style={{ stroke: 'transparent', fill: 'none' }}>
        <path style={{ stroke: 'none' }} d="M0 0h22v22H0z" />
        <path style={{ fill: 'none' }} d="M.5.5h21v21H.5z" />
      </g>
      <path
        data-name="megaphone"
        d="M14.625 2.688a1.688 1.688 0 1 1 3.375 0v12.375a1.688 1.688 0 0 1-3.375 0v-.241a19.128 19.128 0 0 0-7.776-2.343l.451 3.05a1.125 1.125 0 0 1-1.1 1.334h-.618a1.125 1.125 0 0 1-1.03-.674l-2.081-3.927h-.227A2.266 2.266 0 0 1 0 10V7.75a2.273 2.273 0 0 1 2.241-2.265q1.4-.019 2.793-.084a22.207 22.207 0 0 0 9.591-2.474zm1.125 0v12.375a.563.563 0 0 0 1.125 0V2.688a.563.563 0 0 0-1.125 0zm-1.125 1.518a23.6 23.6 0 0 1-9 2.287v4.762q.3.017.6.041a21.036 21.036 0 0 1 8.4 2.242zM4.5 11.2V6.552q-1.12.041-2.241.058a1.148 1.148 0 0 0-1.134 1.14V10a1.142 1.142 0 0 0 1.132 1.135q1.122.013 2.243.063zm-.739 1.1 1.81 3.417.011.027H6.2v-.016l-.5-3.337q-.968-.058-1.937-.092z"
        transform="translate(2 2)"
        style={{ fill: fill }}
      />
    </svg>
  )
}

export const IconAwesome = ({ width = '36', height = '36', fill = '' }) => {
  return (
    <svg
      data-name="Icon awesome-star"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 22 22"
    >
      <g data-name="Rectangle 20409" style={{ stroke: 'transparent', fill: 'none' }}>
        <path style={{ stroke: 'none' }} d="M0 0h22v22H0z" />
        <path style={{ fill: 'none' }} d="M.5.5h21v21H.5z" />
      </g>
      <path
        data-name="Icon awesome-star"
        d="m9.476.6-2.2 4.455-4.913.715a1.077 1.077 0 0 0-.6 1.837l3.556 3.465-.841 4.9A1.076 1.076 0 0 0 6.044 17.1l4.4-2.311 4.4 2.311a1.077 1.077 0 0 0 1.556-1.133l-.841-4.9 3.556-3.465a1.077 1.077 0 0 0-.6-1.837L13.6 5.053 11.407.6a1.078 1.078 0 0 0-1.931 0z"
        transform="translate(.559 2.387)"
        style={{ stroke: fill, strokeWidth: '1.2px', fill: 'none' }}
      />
    </svg>
  )
}

export const IconClock = ({ width = '36', height = '36', fill = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 22">
      <g data-name="Rectangle 20630" style={{ stroke: 'transparent', fill: 'none' }}>
        <path style={{ stroke: 'none' }} d="M0 0h22v22H0z" />
        <path style={{ fill: 'none' }} d="M.5.5h21v21H.5z" />
      </g>
      <g data-name="clock">
        <path
          data-name="Path 24840"
          d="M8.125 3.563a.563.563 0 0 0-1.125 0V9.75a.562.562 0 0 0 .283.488l3.937 2.25a.562.562 0 0 0 .558-.976L8.125 9.424z"
          transform="translate(2.875 2.375)"
          style={{ fill: fill }}
        />
        <path
          data-name="Path 24841"
          d="M9 18a9 9 0 1 0-9-9 9 9 0 0 0 9 9zm7.875-9A7.875 7.875 0 1 1 9 1.125 7.875 7.875 0 0 1 16.875 9z"
          style={{ fill: fill }}
          transform="translate(2 2)"
        />
      </g>
    </svg>
  )
}

export const IconBear = ({ width = '36', height = '36', fill = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 22">
      <defs>
        <clipPath id="h8wgkxulya">
          <path data-name="Rectangle 21526" style={{ fill: fill }} d="M0 0h16v18H0z" />
        </clipPath>
      </defs>
      <g data-name="Rectangle 20409" style={{ stroke: 'transparent', fill: 'none' }}>
        <path style={{ stroke: 'none' }} d="M0 0h22v22H0z" />
        <path style={{ fill: 'none' }} d="M.5.5h21v21H.5z" />
      </g>
      <g data-name="Group 24400">
        <g data-name="Group 24399" style={{ clipPath: 'url(#h8wgkxulya)' }} transform="translate(3 2)">
          <path
            data-name="Path 24846"
            d="M9.862 7.528a11.932 11.932 0 0 1 3.989.554 5.467 5.467 0 0 1 3.665 3.544 7.317 7.317 0 0 1 .295 3 13.687 13.687 0 0 1-2.35 6.317 10.382 10.382 0 0 1-3.311 3.325 3.992 3.992 0 0 1-2.124.639 4.132 4.132 0 0 1-2.072-.654 10.234 10.234 0 0 1-3.076-3 14.92 14.92 0 0 1-2.007-3.993 10.389 10.389 0 0 1-.556-4.17A5.536 5.536 0 0 1 3.96 9.453a6.482 6.482 0 0 1 2.991-1.572 11.877 11.877 0 0 1 2.911-.353m.205 8.557c.355-.038.711-.062 1.063-.116a2.267 2.267 0 0 0 2.026-2.06 4.748 4.748 0 0 0-.653-2.7 4.651 4.651 0 0 0-1.59-1.821 1.379 1.379 0 0 0-1.669.012 5 5 0 0 0-1.03.966 5.017 5.017 0 0 0-1.2 3.6 2.058 2.058 0 0 0 1.2 1.734 4.3 4.3 0 0 0 1.856.388M6.689 9.632a3.813 3.813 0 0 0-.576.251.4.4 0 0 0-.054.7.509.509 0 0 0 .882-.118 1.272 1.272 0 0 0 .139-.411c.04-.259-.091-.381-.391-.423m6.378.4-.057.026a2.884 2.884 0 0 0 .328.578.573.573 0 0 0 .427.133.638.638 0 0 0 .494-.521.548.548 0 0 0-.419-.475 1.335 1.335 0 0 0-.38-.088c-.3-.022-.393.064-.393.347"
            transform="translate(-2.079 -6.904)"
            style={{ fill: fill }}
          />
          <path
            data-name="Path 24847"
            d="M0 .645C0 .185.186 0 .674.012a1.938 1.938 0 0 1 1.373.557.693.693 0 0 1 .063.974 2.041 2.041 0 0 1-.455.43.848.848 0 0 1-1.165-.137A1.75 1.75 0 0 1 0 .645"
            transform="translate(0 -.011)"
            style={{ fill: fill }}
          />
          <path
            data-name="Path 24848"
            d="M156.811.768a1.7 1.7 0 0 1-.582 1.142.793.793 0 0 1-1 .094 2.144 2.144 0 0 1-.544-.5.685.685 0 0 1 .105-.972A1.977 1.977 0 0 1 156.266 0c.389.014.54.209.545.765"
            transform="translate(-140.811 -.001)"
            style={{ fill: fill }}
          />
          <path
            data-name="Path 24849"
            d="M73.251 42.811a2.1 2.1 0 0 1 1.308.362.72.72 0 0 1 .348.611c0 .14-.054.245-.247.183a.767.767 0 0 0-.876.293c-.081.1-.138.21-.215.31a.386.386 0 0 1-.611 0c-.075-.1-.129-.216-.21-.312a.769.769 0 0 0-.878-.288c-.174.056-.232-.024-.239-.165a.77.77 0 0 1 .46-.707 2.077 2.077 0 0 1 1.16-.286"
            transform="translate(-65.273 -39.26)"
            style={{ fill: fill }}
          />
        </g>
      </g>
    </svg>
  )
}
